import React, { useContext, useEffect, useState } from 'react'
import ImgStep0 from '../assets/rewardStep0.png'
import UserContext from 'contexts/UserContext'
import { OpenTutorial, SkipTutorial } from 'requests/game'
import ModalInfoReward from './ModalInfoReward'
import { useNavigate } from 'react-router-dom'

interface Props {
  handleSkip?: () => void
  handlerading?: () => void
  setIsOpenModal: (val: boolean) => void
  isOpenModal: boolean
}
const ModalFirstOpendTuto: React.FC<Props> = ({  setIsOpenModal }) => {
  const { user, setUser } = useContext(UserContext)
  const id = user?.user?._id
  const token = user?.token?.accessToken

  const Navigation = useNavigate()
  const [isOpenModalSatrtReading, setIsOpenModalSatrtReading] = useState(false)

  const handleISOpenTutorial = async () => {
    if (!id || !token || !user) return

    try {
      const response = await OpenTutorial(id, token)
      setUser({
        ...user,
        user: {
          ...user.user,
          game: {
            ...user.user.game,
            isTutoOpened: response?.game?.isTutoOpened,
          },
        },
      })
      setIsOpenModal(false)
    setIsOpenModalSatrtReading(false)


    } catch (error) {
      console.error('Error opening tutorial:', error)
    }
  }

 const handleReadingTuto=()=>{
    handleISOpenTutorial()
    Navigation('/Rewards')

 }

  const handleSkipTutorial = async () => {
    if (!id || !token || !user) return

    try {
      const response = await SkipTutorial(id, token)

      setUser({
        ...user,
        user: {
          ...user.user,
          game: {
            ...user.user.game,
            isTutoSkiped: response?.game?.isTutoSkiped,
            isTutoOpened: true,
          },
        },
      })
      handleISOpenTutorial()
    } catch (error) {
      console.error('Error skipping tutorial:', error)
    }
  }

  useEffect(() => {
    if (isOpenModalSatrtReading === false) {
      // handleStartTutorial()
    }
  }, [isOpenModalSatrtReading])

  return (
    <div>
      {!isOpenModalSatrtReading ? (
        <div className="fixed inset-0 bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] flex items-center justify-center z-50  ">
          <div
            className={`relative bg-white rounded-2xl sm:mx-[4px] shadow-inner flex flex-col gap-8 max-h-screen object-center w-auto sm:w-full  px-8 py-[60px] 3xl:py-[20px]`}
          >
             <div className="flex cursor-default flex-col items-center justify-center ">
              <img
                className="h-[340px] 2xl:h-[200px] w-auto"
                src={ImgStep0}
                width={236}
                height={254}
                alt="Let’s play & win!"
              />
              <h2 className="text-[#5754E5] text-[22px] font-bold"> Jouez et gagnez !</h2>
              <p className="max-w-[400px] text-center text-[#6B7280] h-[180px] 3xl:h-[100px] overflow-y-auto scrollbar-webkit py-2">
                Découvrez de nouvelles fonctionnalités conçues pour récompenser votre engagement et vous donner encore
                plus de chances de remporter des cadeaux, des packs de services gratuits et des avantages exclusifs.
              </p>
            </div>

            <button
              className="text-white font-roboto text-[18px] bg-[#5754E5] cursor-pointer font-bold rounded-[16px] h-[56px] w-full"
              onClick={() => {
                setIsOpenModalSatrtReading(true)
                // handleStartTutorial()
              }}
            >
              Découvrir maintenant
            </button>
            <button
              className="text-[#5754E5] font-roboto text-[18px] cursor-pointer font-bold h-[56px]"
              onClick={() => {
                handleSkipTutorial()
              }}
            >
              Plus tard
            </button>
          </div>
        </div>
      ) : (
        <div className="bg-transparent inset-0 z-50 w-full h-screen">
          <ModalInfoReward handleStartTutorial={handleReadingTuto} />
        </div>
      )}
    </div>
  )
}

export default ModalFirstOpendTuto
